<template>
    <div class="student-index-container">
        <div class="header">
            当前位置:
            <div style="margin-left: 5px;">
                <span>
                  
                    <span style="color:#ffffff;cursor: pointer;" @click="getClassList">课程 </span>
                </span>
                <span>
                    <span> > </span>
                    <span v-if="isChosen !== true"  style="color:#ffffff">{{ select_courseName }}</span>
                    <span v-else>课程总览</span>
                </span>
            </div>
           
        </div>
        <div class="main">
            <div class="course-left">

                <div class="container">
                    <router-view v-if="activeName === 'studentFeatured' || 'studentCourseIndex'" 
                    :courseInfos="courseInfos" :nodeIndex="nodeIndex" :zhangName="zhangName" :jieName="jieName" :chapterIndex="chapterIndex" />
                    <router-view v-else />
                </div>
            </div>
            <div class="course-right">
                <div class="select_class">
                    <span class="tip">课程目录</span>
                    <div class="dark-select">
                        <el-select v-model="select_course" placeholder="请选择课程" :popper-append-to-body="false" clearable
                            class="provinces_select" @change="chooseCourse">
                            <el-option v-for="item in studentCourseList" :key="item.course_id" :label="item.course_name"
                                :value="item.course_id"></el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item-title" :class="isChosen === true ? 'choseAll' : ''" @click="choseAll">
                    <span><i class="iconfont play-icon" style="margin-right: 6px;">&#xe719;</i></span> <span
                        class="text" style="cursor: pointer;">课程总览</span>
                </div>
                <el-scrollbar :native="false">
                    <div class="zhang-jie">
                        <div class="zhang-jie-item" :class="setClass(zhangIndex)"
                            v-for="(zhangItem, zhangIndex) in courseZhangJie">
                            <div class="zhang" :class="{ currentZhang: (chapterIndex == zhangIndex && isChosen==false) }"
                                :title="`第${zhangIndex + 1}章：${zhangItem.name}（${zhangItem.children.length}节）`">
                                <span class="text">第{{ zhangIndex + 1 }}章：{{ zhangItem.name }}（{{ zhangItem.children.length
                                }}节）</span>
                            </div>
                            <div class="jie-box">
                                <div class="jie-inside-box">
                                    <div class="jie"
                                        :class="{ current: currentJie === jieIndex && chapterIndex == zhangIndex }"
                                        v-for="(jieItem, jieIndex) in zhangItem.children"
                                        @click="clickJie(zhangIndex, jieIndex,jieItem,zhangItem)"
                                        :title="`第${jieIndex + 1}课   ${jieItem.name}`">
                                        <span class="text"
                                            :class="{ class_name: jieIndex != (zhangItem.children.length - 1), class_name1: jieIndex !== 0 }">
                                            第 {{ jieIndex + 1 }} 课 {{ jieItem.name }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-scrollbar>
            </div>

        </div>
    </div>
</template>

<script>
    import _ from "underscore";
    import CourseIndex from 'components/Student/course/CourseIndex.vue'
    import Featured from 'components/Student/course/Featured.vue'
    import CourseWare from 'components/Student/course/CourseWare.vue'
    import Textbook from 'components/Student/course/Textbook.vue'
    import MicroLesson from 'components/Student/course/MicroLesson.vue'
    import Animation from 'components/Student/course/Animation.vue'

    export default {
        name: "Course",
        data() {
            return {
                isChosen: true,
                activeName: 'studentCourseIndex',
                //选择的课程
                select_course: '',
                //课程列表
                studentCourseList: [],
                //章节
                courseZhangJie: [],
                //
                currentJie: 0,
                //总管理员分配的章节
                allocatedCourse: [],
                allocatedCourseNum: null,
                //课程介绍
                courseInfos: {},
                zhang_arr: [],
                nodeIndex: 0,
                chapterIndex: 0,
                select_courseName:"",
                zhangName:"",
                jieName:""
            }
        },
        components: {
            CourseIndex,
            Featured,
            CourseWare,
            Textbook,
            MicroLesson,
            Animation,
        },
        created() {
            this.activeName = this.$route.meta.tabName;
            this.getAdminCourseList();
            console.log(this.activeName,"1111111111");
            if (this.activeName === 'studentCourseIndex') {
                this.isChosen = true;
                this.currentJie = '';
            }
            if (this.activeName === 'studentFeatured' || this.activeName=='studentFeaturedDetail') {
                this.isChosen = false;
                this.chapterIndex = localStorage.getItem('studentChapter');
                this.nodeIndex = localStorage.getItem('studentNode');
                this.currentJie = Number(this.nodeIndex);
                this.jieName=localStorage.getItem("jieName")
                this.zhangName=localStorage.getItem("zhangName")
            }

          this.setKey()
        },
        watch: {
            $route(route) {
                console.log(route,"1111111111");
                if (route.name === 'studentCourseIndex') {
                    this.activeName = 'studentCourseIndex';
                    this.isChosen = true;
                    this.currentJie = '';
                } else if (route.name === 'studentFeatured' || route.meta.tabName=='studentFeaturedDetail') {
                    this.activeName = 'studentFeatured';
                    this.isChosen = false;
                }
              this.setKey()
            }
        },
        methods: {
          setKey() {
            if (this.$route.name === 'studentFeaturedDetail') {
              document.oncontextmenu = function () {
                return false
              }
              document.onkeydown = function () {
                console.log('window.event.keyCode', window.event.keyCode)
                if(window.event && window.event.keyCode === 123) {
                  // alert("F12被禁用");
                  // event.keyCode = 0;
                  event.returnValue = false;
                }
                if(window.event && window.event.keyCode === 13) {
                  // alert("3333");
                  window.event.keyCode = 505;
                }
                if(window.event && window.event.keyCode === 8) {
                  // alert(str+"\n请使用Del键进行字符的删除操作！");
                  window.event.returnValue = false;
                }
              }
            } else {
              document.oncontextmenu = function () {
                return true
              }
              document.onkeydown = function () {
                console.log('window.event.keyCode', window.event.keyCode)
                if(window.event && window.event.keyCode === 123) {
                  event.returnValue = true;
                }
                if(window.event && window.event.keyCode === 13) {
                  window.event.keyCode = 505;
                }
                if(window.event && window.event.keyCode === 8) {
                  window.event.returnValue = true;
                }
              }
            }
          },
            setClass(index) {
                const course_id = this.$route.query.course_id
                if (this.zhang_arr[course_id] != undefined && this.zhang_arr[course_id][index] !== undefined) {
                    return 'isAllocatedClass';
                } else {
                    return "";
                }
            },
            //获取课程列表
            getAdminCourseList() {
                let param = {
                    type: 1,
                    parent_id: 'no',
                    sort: 1,
                }
                this.$shttp.axiosGetBy(this.$api.admin_courseLists, param, (res) => {
                    if (res.code === 200) {
                        this.studentCourseList = res.list;
                        if (this.$route.query.course_id) {
                            this.select_course = Number(this.$route.query.course_id);
                        } else {
                            this.select_course = res.list[0].course_id;
                            this.$router.push({
                                query: {
                                    course_id: this.select_course,
                                },
                            });
                        }
                        let course_id = 0;
                        if (this.select_course) {
                            this.getCourseInfo(this.select_course);
                            course_id = this.select_course;
                        }

                        let tmpObj = res.list[0].course_data.course_content;
                        if (course_id) {
                            let tmp_arr = _.find(res.list, {course_id: course_id});
                            tmpObj = tmp_arr.course_data.course_content;
                        }
                        let zhang_arr = [];
                        if (res.allowed_data && res.allowed_data.length > 0) {
                            // console.log("allowed", res.allowed_data)
                            res.allowed_data.forEach((item)  => {
                                // console.log("course_id", item)
                                if (zhang_arr[item.course_id]) {
                                    zhang_arr[item.course_id].push(item.zhang_arr)
                                } else {
                                    zhang_arr[item.course_id] = [item.zhang_arr];
                                }
                            })
                            this.zhang_arr = zhang_arr
                        }

                        // for (let j = 0; j < tmpObj.length; j++) {
                        //     zhang_arr.push(j + 1);
                        // }
                        // this.zhang_arr = zhang_arr;
                        let obj=this.studentCourseList.find(item=>item.course_id==this.select_course)
         
                    this.select_courseName=obj.course_name
                    } else {
                        this.$message.error(res.msg);
                    }
                }, (err) => {
                    console.log(err);
                })
            },
            choseAll() {
                this.isChosen = true;
                this.currentJie = '';
                this.$router.push({
                    path: '/qualityCourse/courseindex',
                    query: {
                        course_id: this.select_course
                    }
                })
            },
            //选择课程
            chooseCourse(val) {
                this.currentJie = '';
                this.chapterIndex = 0;
                this.nodeIndex = 0;
                this.jieName=""
                this.zhangName=""
                this.$router.push({
                    path: '/qualityCourse/courseindex',
                    query: {
                        course_id: val,
                    },
                });
                localStorage.setItem("course_id",this.select_course)
                this.getCourseInfo(val);
                this.getAdminCourseList();
            },
            //获取课程详情
            getCourseInfo(courseId) {
                let params = {
                    id: courseId,
                    class_id:localStorage.getItem("c_id")
                };
                this.$shttp.axiosGetBy(this.$api.courseinfo, params, (res) => {
                    if (res.code === 200) {
                        this.courseZhangJie = res.data.course_content;
                        this.courseInfos = res.data;
                    }
                }, (error) => {
                    console.log(error);
                })
            },
            //
            clickJie(index, jIndex,jieItem,zhangItem) {
                console.log(jieItem,"123",zhangItem);
                
                if(!jieItem.pusher){
                    this.$message.warning("暂无查看权限")
                    return 
                }
                

                // if (this.zhang_arr[this.select_course] != undefined && this.zhang_arr[this.select_course][index] != undefined) {
                    this.chapterIndex = index;
                    this.nodeIndex = jIndex;
                    this.jieName=jieItem.name
                    this.zhangName=zhangItem.name
                    localStorage.setItem("course_id",this.select_course)
                    localStorage.setItem('jieName', this.jieName);
                    localStorage.setItem('zhangName', this.zhangName);
                    localStorage.setItem('studentChapter', index);
                    localStorage.setItem('studentNode', jIndex);
                    this.isChosen=false

                    this.currentJie = jIndex;
                    this.$router.push({
                        path: '/qualityCourse/featured',
                        query: {
                            course_id: this.select_course,
                            zhangIndex: index,
                            jieIndex: jIndex
                        }
                    });
                // } else  {
                //     this.$message.warning("未授权的内容，无法查看")
                // }
            },
            handleClick(tab, event) {
                this.$router.push({
                    name: tab.name,
                    query: {
                        course_id: this.select_course
                    },
                })
            },
            getClassList(){
                this.$router.push("/qualityCourse/courseindex")
            }
        }
    }
</script>

<style scoped lang="scss">
.student-index-container {
    width: 100%;
    height: 100%;
    box-sizing: border-box;

    .header {
        width: 100%;
        height: 42px;
        background-color: #282828;
        padding: 0 100px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        color: #FFFFFF;

    }

    .main {
        display: flex;
        width: 100%;
        height: calc(100vh - 112px);
        box-sizing: border-box;

        .course-left {
            width: 0;
            flex: 1;
            height: 100%;
            display: flex;


            .container {
                width: 0;
                flex: 1;
                height: 100% !important;

            }

            .resource_navigation {
                width: 80px;
                height: 100%;
                background: #333333;
                padding: 15px 0;
                box-sizing: border-box;

                .featured-right {
                    .resource {
                        .resourse_item {

                            ::v-deep .inner-box {
                                width: 100%;
                                color: #999999;
                                height: 90px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                flex-direction: column;

                                .resourse_title {
                                    margin-top: 10px;
                                    font-size: 14px;
                                }


                            }

                            ::v-deep .active_resourse_item {
                                background-color: #1E1E1E !important;
                                color: #FFFFFF;

                            }


                        }


                    }

                }
            }




        }

        .course-right {
            width: 340px;
            height: calc(100vh - 112px);
            background-color: #2D2D2D;
            color: #999999;
            // overflow-y: auto;

            .select_class {
                width: 100%;
                height: 80px;
                // background-color: pink;
                display: flex;
                align-items: center;
                padding: 24px;
                box-sizing: border-box;

                .tip {
                    padding-right: 6px;
                    font-size: 16px;
                }
            }

            .item-title {
                height: 53px;
                // background-color: pink;
                display: flex;
                align-items: center;
                padding: 0px 24px;
                box-sizing: border-box;
                font-weight: 400;
                font-size: 16px;
                line-height: 19px;
                text-align: left;
                font-style: normal;
                text-transform: none;
                color: #999999;
            }

            .choseAll {
                color: #FFFFFF !important;
                background-color: #282828;
            }

            .zhang-jie {
                max-height: calc(100vh - 280px) !important;

                .zhang-jie-item {
                    width: 100%;
                    // padding: 10px 0;
                    // padding-left: 24px;
                    // background-color: pink;
                    // background-color: pink;
                    box-sizing: border-box;


                    .zhang {
                        width: 320px;
                        display: inline-block;
                        white-space: nowrap; 
                        overflow: hidden;
                        text-overflow: ellipsis; 
                        padding: 10px 0;
                        box-sizing: border-box;
                        padding-left: 24px;
                    }
                    .currentZhang{
                        color: #FFFFFF;
                    }

                    .jie-box {

                        .jie {
                            height: 53px;
                            display: flex;
                            align-items: center;
                            cursor: pointer;
                            box-sizing: border-box;
                            color: rgba(255, 255, 255, 0.50) !important;
                            position: relative;
                            /* 确保伪元素定位相对于父元素 */
                            padding-left: 54px;
                            font-size: 16px;
                            /* 当有多个 .jie 元素时，处理连接线的显示 */
                            .class_name::after {
                                content: '';
                                position: absolute;
                                width: 1px;
                                height: 19px;
                                /* 延长线的长度，确保连接到下一个 .jie 元素的顶部 */
                                background-color: rgba(255, 255, 255, 0.50) !important;
                                left: 31.5px !important;
                                /* 让线从圆圈的中心点位置开始 */
                                top: 34px;
                                /* 线的起点在当前 .jie 元素的底部 */
                                z-index: 100 !important;

                            }

                            .class_name1::before {
                                content: '';
                                position: absolute;
                                width: 1px;
                                height: 19px;
                                /* 延长线的长度，确保连接到下一个 .jie 元素的顶部 */
                                background-color: #999999;
                                left: 31.5px !important;
                                /* 让线从圆圈的中心点位置开始 */
                                top: 0px;
                                /* 线的起点在当前 .jie 元素的底部 */

                            }
                            .text{
                                width: 270px;
                                display: inline-block;
                                white-space: nowrap; 
                                overflow: hidden;
                                text-overflow: ellipsis; 
                            }

                        }

                        .jie::before {
                            content: '';
                            display: inline-block;
                            width: 15px;
                            height: 15px;
                            border: 1px solid rgba(255, 255, 255, 0.5);
                            border-radius: 50%;
                            position: absolute;
                            left: 24px;
                            top: 50%;
                            transform: translateY(-50%);
                            box-sizing: border-box;
                        }

                        .current {
                            color: #FFFFFF !important;
                            background-color: #282828;
                        }



                        .current::after {
                            content: '';
                            display: inline-block;
                            width: 8px;
                            height: 8px;
                            background-color: #FFFFFF;
                            /* 实心圆颜色 */
                            border-radius: 50%;
                            position: absolute;
                            left: 9%;
                            top: 50%;
                            transform: translate(-39%, -50%);


                        }

                    }
                }
            }
        }
    }

}

::v-deep .el-input__inner {
    height: 36px;
    background-color: #1E1E1E;
    color: #FFFFFF ;
}

::v-deep .el-select .el-input.is-focus .el-input__inner {
    border-color: #2D2D2D !important;
}

::v-deep .el-select-dropdown .el-popper {
    background-color: #2D2D2D !important;
    box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.15);
    color: #999999 !important;

}

.dark-select ::v-deep input::-webkit-input-placeholder {
    color: rgba(255, 255, 255, 0.50);
}

.dark-select ::v-deep input::-moz-input-placeholder {
    color: rgba(255, 255, 255, 0.50);
}

.dark-select ::v-deep input::-ms-input-placeholder {
    color: rgba(255, 255, 255, 0.50);
}

.dark-select ::v-deep .el-select,
.dark-select ::v-deep .el-input,
.dark-select ::v-deep .el-input__inner {
    background-color: rgba(255, 255, 255, 0.04);
    color: rgba(255, 255, 255, 0.50);
    border: none;
    /* 去掉边框 */
    border-radius: 4px;
    text-align: left;
}

.dark-select ::v-deep .el-input__inner:hover {
    background-color: rgba(255, 255, 255, 0.12);
}

.dark-select ::v-deep .el-select .el-input .el-select__caret {
    color: #748092;
    background-color: #FFFFFF;
    width: 20px;
    height: 20px;
    margin-top: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
}

.dark-select ::v-deep .el-popper[x-placement^="bottom"] .popper__arrow::after {
    border-bottom-color: rgba(43, 45, 55, 0.80);
    z-index: 9999;
}

.dark-select ::v-deep .popper__arrow {
    border: none;
}

.dark-select ::v-deep .el-select-dropdown {
    border: none !important;
    background: #2D2D2D !important;
    box-shadow: 1px 4px 20px 4px rgba(0, 0, 0, 0.25), 1px 4px 20px 4px rgba(0, 0, 0, 0.25);
    z-index: 9999;
    left: -63px !important;
}

.dark-select ::v-deep .el-select-dropdown__item {
    color: rgba(255, 255, 255, 0.50) !important;
    position: relative;
    /* 确保伪元素定位相对于父元素 */
    padding-left: 30px;
    /* 增加左侧留白，为伪元素空心圆留位置 */
    line-height: 40px;
    /* 调整行高以居中显示 */
    cursor: pointer;
    /* 鼠标指针样式 */
}

.dark-select ::v-deep .el-select-dropdown__item.selected span {
    color: rgba(255, 255, 255, 0.80) !important;
}

.dark-select ::v-deep .el-select-dropdown__item.hover {
    background-color: rgba(255, 255, 255, 0.06);
    color: rgba(255, 255, 255, 0.80) !important;
}

.dark-select ::v-deep .el-scrollbar__bar.is-vertical {
    width: 10px;
    top: 2px;
}

.dark-select ::v-deep .el-select-dropdown__wrap {
    max-height: 329px;
    width: 300px;
}

// .dark-select ::v-deep .el-select-dropdown__item {
//     position: relative; /* 确保伪元素定位相对于父元素 */
//     padding-left: 20px; /* 增加左侧留白，为伪元素空心圆留位置 */
//     line-height: 40px; /* 调整行高以居中显示 */
//     cursor: pointer; /* 鼠标指针样式 */

//     /* 其他样式保持不变 */
//     color: rgba(255, 255, 255, 0.50) !important;
// }

.dark-select ::v-deep .el-select-dropdown__item.selected {
    color: rgba(255, 255, 255, 0.80) !important;
}

.dark-select ::v-deep .el-select-dropdown__item::before {
    content: '';
    display: inline-block;
    width: 18px;
    height: 18px;
    border: 1px solid rgba(255, 255, 255, 0.5);
    border-radius: 50%;
    position: absolute;
    left: 6px;
    /* 调整位置以与文本对齐 */
    top: 50%;
    transform: translateY(-50%);
    box-sizing: border-box;
    /* 边框大小不影响元素尺寸 */
}

.dark-select ::v-deep .el-select-dropdown__item.selected::before {
    background-color: transparent;
    /* 空心圆背景透明 */
    border-color: rgba(255, 255, 255, 0.8);
    /* 边框颜色 */
}

.dark-select ::v-deep .el-select-dropdown__item.selected::after {
    content: '';
    display: inline-block;
    width: 9px;
    height: 9px;
    background-color: #FFFFFF;
    /* 实心圆颜色 */
    border-radius: 50%;
    position: absolute;
    left: 4%;
    top: 50%;
    transform: translate(-8%, -50%);
}
</style>